export default "__VITE_ASSET__BQOKsylV__"